import type { TelemetryEvent } from "./types";

type TelemetrySink = (event: TelemetryEvent) => void;

let telemetrySink: TelemetrySink | null = null;

export function configureTelemetrySink(nextSink: TelemetrySink | null): void {
  telemetrySink = nextSink;
}

export function emitTelemetry(events: TelemetryEvent[]): void {
  events.forEach((event) => {
    if (telemetrySink !== null) {
      telemetrySink(event);
      return;
    }

    console.info("[telemetry]", event.name, event.payload);
  });
}
